import { Extension } from "../../core/extension";
import { SlashCommandGroup, } from "../../core/types";
import { TocView } from "./nodeviews";
import { TocPlugin } from "./plugins";
import { createTocCommand } from "./commands";
import { tocNodeSpec } from "./schema";
export class TocExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(tocNodeSpec());
    }
    addNodeViews(schema, nodeViews) {
        return {
            ...nodeViews,
            toc: (node, view, getPos) => new TocView(node, view, getPos),
        };
    }
    addPlugins(schema, plugins) {
        return plugins.concat([TocPlugin()]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Table of contents`,
                description: `Shows the current headings outline`,
                group: SlashCommandGroup.Advanced,
                icon: "is-document",
                command: createTocCommand(),
            },
        ];
    }
}
